// InventoryExpiryWidget.js — small Dashboard card summarising batch expiry.
// Fully dynamic (reads /stockreport/expiry-summary), auto-refreshes, and each
// count deep-links into the Expiry Report pre-filtered. Self-contained so it
// drops into the Dashboard with a single <InventoryExpiryWidget /> line.
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, Box, Typography, Grid } from '@mui/material';
import config from '../../config';

const CELLS = [
  { k: 'expired', label: 'Expired', c: '#DC2626', icon: 'dangerous', f: 'expired' },
  { k: 'today', label: 'Expiring Today', c: '#DC2626', icon: 'today', f: 'today' },
  { k: 'next7', label: 'Within 7 Days', c: '#EA580C', icon: 'schedule', f: 'next7' },
  { k: 'next30', label: 'Within 30 Days', c: '#CA8A04', icon: 'event', f: 'next30' },
];

export default function InventoryExpiryWidget() {
  const navigate = useNavigate();
  const [sum, setSum] = useState(null);

  useEffect(() => {
    const company = JSON.parse(sessionStorage.getItem('companyDetails') || '{}');
    const load = async () => {
      try {
        if (!company?.id) return;
        const token = sessionStorage.getItem('token');
        const res = await fetch(
          `${config.API_BASE_URL}/stockreport/expiry-summary/${company.id}`,
          { headers: { Authorization: `Bearer ${token}` } },
        );
        if (!res.ok) return;
        const j = await res.json();
        setSum(j.summary || {});
      } catch { /* silent */ }
    };
    load();
    const t = setInterval(load, 60000);
    return () => clearInterval(t);
  }, []);

  if (!sum) return null;
  const total = CELLS.reduce((a, c) => a + (sum[c.k] || 0), 0);

  return (
    <Card
      elevation={0}
      sx={{ borderRadius: '14px', border: '1px solid #E7ECF3', p: 2, boxShadow: '0 1px 3px rgba(15,23,42,0.06)', height: '100%' }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1.5 }}>
        <span className='material-symbols-rounded' style={{ fontSize: 20, color: '#C8102E' }}>inventory_2</span>
        <Typography sx={{ fontWeight: 800, color: '#1A2238' }}>Inventory Expiry</Typography>
        <Box sx={{ flex: 1 }} />
        <Typography
          onClick={() => navigate('/admin/ExpiryReport')}
          sx={{ cursor: 'pointer', fontSize: 12, fontWeight: 700, color: '#C8102E' }}>
          View →
        </Typography>
      </Box>
      {total === 0 ? (
        <Typography sx={{ color: '#16A34A', fontSize: 13, py: 1.5 }}>All stock within safe expiry. 🎉</Typography>
      ) : (
        <Grid container spacing={1}>
          {CELLS.map((c) => (
            <Grid item xs={6} sm={3} key={c.k}>
              <Box
                onClick={() => navigate(`/admin/ExpiryReport?bucket=${c.f}`)}
                sx={{ cursor: 'pointer', p: 1.2, borderRadius: '10px', background: `${c.c}0D`, border: `1px solid ${c.c}22`, textAlign: 'center', transition: 'all .15s', '&:hover': { background: `${c.c}18` } }}>
                <span className='material-symbols-rounded' style={{ fontSize: 18, color: c.c }}>{c.icon}</span>
                <Typography sx={{ fontWeight: 800, color: c.c, fontSize: 22, lineHeight: 1.1 }}>{sum[c.k] || 0}</Typography>
                <Typography sx={{ fontSize: 11, color: '#64748b', fontWeight: 600 }}>{c.label}</Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      )}
    </Card>
  );
}
